import React, { useState } from 'react'
import { connect } from 'react-redux'

import { makeStyles, Typography } from '@material-ui/core'
import { ReactComponent as CapeeshLogo } from 'assets/images/capeesh_logo.svg'
import { studentAuthActions } from '../../_state/actions'
import { CapeeshColors } from '../../assets/ColorPalette'
import { Button, TextField, CircularProgress } from '@mui/material'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        padding: 30,
    },
    capeeshLogo: {
        fill: CapeeshColors.Primary900,
        display: 'inherit',
        margin: '20px auto',
    },
    centerMidDiv: {
        display: 'flex',
        justifyContent: 'center',
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        maxWidth: '450px',
        margin: '0 auto',
        padding: '0 16px',
    },
    card: {
        width: '100%',
        padding: '32px',
        borderRadius: '12px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    successCard: {
        width: '100%',
        padding: '32px',
        borderRadius: '12px',
        backgroundColor: '#f0faf0',
        border: '1px solid #80D387',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        textAlign: 'center',
    },
}))

const StudentForgotPassword = (props) => {
    const classes = useStyles()
    const [email, setEmail] = useState('')

    const handleSendLoginLink = () => {
        if (email) {
            props.dispatch(studentAuthActions.studentForgotPasswordAccessCode(email))
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendLoginLink()
        }
    }

    const linkSent = props.studentAuth.resetStep === 1

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
            <div className={classes.centerMidDiv}>
                <CapeeshLogo width={300} height={100} className={classes.capeeshLogo} />
            </div>
            <div className={classes.mainContainer}>
                {!linkSent ? (
                    <div className={classes.card}>
                        <Typography variant="h5" style={{ fontWeight: 600 }}>
                            <FormattedMessage
                                id="student.forgotpassword.title"
                                defaultMessage="Need to log in?"
                            />
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            <FormattedMessage
                                id="student.forgotpassword.description"
                                defaultMessage="Enter your email address and we'll send you a link to log in directly — no password needed."
                            />
                        </Typography>
                        <TextField
                            id="emailAddress"
                            label={
                                <FormattedMessage
                                    id="student.forgotpassword.email.label"
                                    defaultMessage="Email address"
                                />
                            }
                            placeholder="john.smith@yourcompany.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyPress={handleKeyPress}
                            fullWidth
                            variant="outlined"
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSendLoginLink}
                            disabled={!email || props.studentAuth.sendingEmail}
                            fullWidth
                            style={{ height: '48px', textTransform: 'none', fontSize: '16px' }}>
                            {props.studentAuth.sendingEmail ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                <FormattedMessage
                                    id="student.forgotpassword.send.link"
                                    defaultMessage="Send login link"
                                />
                            )}
                        </Button>
                    </div>
                ) : (
                    <div className={classes.successCard}>
                        <CheckCircleOutlineIcon style={{ fontSize: 48, color: CapeeshColors.GreenBright }} />
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                            <FormattedMessage
                                id="student.forgotpassword.link.sent.title"
                                defaultMessage="Login link sent!"
                            />
                        </Typography>
                        <Typography variant="body1" color="textSecondary">
                            <FormattedMessage
                                id="student.forgotpassword.link.sent.description"
                                defaultMessage="We've sent you an email with a login link valid for 4 hours. Check your inbox and click the link to sign in."
                            />
                        </Typography>
                    </div>
                )}

                <Button
                    variant="outlined"
                    color="primary"
                    component={Link}
                    to={'/student/login'}
                    startIcon={<ArrowBackIcon />}
                    style={{ textTransform: 'none' }}>
                    <FormattedMessage
                        id="student.forgotpassword.back.to.login"
                        defaultMessage="Back to login"
                    />
                </Button>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return { dispatch: dispatch }
}

function mapStateToProps(state) {
    const { studentAuth } = state
    return {
        studentAuth: studentAuth,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentForgotPassword)
